// extracted by mini-css-extract-plugin
export default {"OtherUserFollowPageContainer":"OtherUserFollowPage_OtherUserFollowPageContainer__Ma5Kw"};